import React from "react";
import axios from "axios";
import Banner from "../../components/Banner";
import { Sidebar } from "../../components/Sidebar";
import Spinner from "../../components/Spinner";
import "../../css/Wireframe.css";

const API = localStorage.getItem("assethost");

export default class UploadDocuments extends React.Component {
  constructor(props) {
    super(props);

    // Get URL parameters to check for specific document type
    const urlParams = new URLSearchParams(window.location.search);
    const documentTypeParam = urlParams.get("systemMessageType");

    this.state = {
      documentType: documentTypeParam || "ALL",
      individualProfileId:
        parseInt(sessionStorage.getItem("individualProfileId")) || 0,
      companyProfileId:
        parseInt(sessionStorage.getItem("companyProfileId")) || 0,
      lawEnforcementProfileId:
        parseInt(sessionStorage.getItem("lawEnforcementProfileId")) || 0,

      // Document states
      documents: {
        individualNationalId: null,
        individualPassport: null,
        corporatePrimaryContactNationalId: null,
        corporatePrimaryContactPassport: null,
        corporateBillingContactNationalId: null,
        corporateBillingContactPassport: null,
        corporateCR14: null,
        corporateCertificateOfIncorporation: null,
        lawEnforcementNationalId: null,
      },

      // Existing document info
      existingDocuments: {
        individualNationalId: null,
        individualPassport: null,
        corporatePrimaryContactNationalId: null,
        corporatePrimaryContactPassport: null,
        corporateBillingContactNationalId: null,
        corporateBillingContactPassport: null,
        corporateCR14: null,
        corporateCertificateOfIncorporation: null,
        lawEnforcementNationalId: null,
      },

      // Upload states
      uploading: {},

      // UI state
      loading: false,
      msg: "",
      toastColor: "",
      errors: {},
    };

    this.handleFileChange = this.handleFileChange.bind(this);
    this.handleUpload = this.handleUpload.bind(this);
    this.fetchExistingDocuments = this.fetchExistingDocuments.bind(this);
    this.getDocumentTypeFromParam = this.getDocumentTypeFromParam.bind(this);
    this.shouldShowDocument = this.shouldShowDocument.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
      window.href = `/?redirectUrl=${window.location.pathname + window.location.search
        }`;
      return;
    }

    this.fetchExistingDocuments(token);
  }

  getDocumentTypeFromParam() {
    const {
      documentType,
      individualProfileId,
      companyProfileId,
      // eslint-disable-next-line no-unused-vars
      lawEnforcementProfileId,
    } = this.state;

    if (documentType === "ALL") return "ALL";

    // Map document type parameters to specific documents
    switch (documentType) {
      case "MISSING_IDENTITY_DOCUMENTS":
        if (individualProfileId > 0) return "INDIVIDUAL_IDENTITY";
        break;
      case "CERTFICATE_OF_INCORPATION":
        if (companyProfileId > 0) return "CERTIFICATE_OF_INCORPORATION";
        break;
      case "CR14":
        if (companyProfileId > 0) return "CR14";
        break;
      case "MISSING_IDENTITY_DOCUMENTS_COMPANY":
        if (companyProfileId > 0) return "CORPORATE_IDENTITY";
        break;
      default:
        return "ALL";
    }
    return "ALL";
  }

  shouldShowDocument(documentKey) {
    const { individualProfileId, companyProfileId, lawEnforcementProfileId } =
      this.state;
    const specificType = this.getDocumentTypeFromParam();

    // If showing all documents, check profile types
    if (specificType === "ALL") {
      if (documentKey.startsWith("individual") && individualProfileId <= 0)
        return false;
      if (documentKey.startsWith("corporate") && companyProfileId <= 0)
        return false;
      if (
        documentKey.startsWith("lawEnforcement") &&
        lawEnforcementProfileId <= 0
      )
        return false;
      return true;
    }

    // Show specific document types based on parameter
    switch (specificType) {
      case "INDIVIDUAL_IDENTITY":
        return (
          documentKey === "individualNationalId" ||
          documentKey === "individualPassport"
        );
      case "CERTIFICATE_OF_INCORPORATION":
        return documentKey === "corporateCertificateOfIncorporation";
      case "CR14":
        return documentKey === "corporateCR14";
      case "CORPORATE_IDENTITY":
        return (
          documentKey.includes("corporatePrimaryContact") ||
          documentKey.includes("corporateBillingContact")
        );
      default:
        return false;
    }
  }

  fetchExistingDocuments(token) {
    this.setState({ loading: true, msg: "", toastColor: "" });

    const { individualProfileId, companyProfileId, lawEnforcementProfileId } =
      this.state;
    const promises = [];

    // Fetch individual documents
    if (individualProfileId > 0) {
      promises.push(
        axios
          .get(`${API}/profile/individual/documents/${individualProfileId}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((response) => ({
            type: "individual",
            data: response.data,
          }))
          .catch(() => ({ type: "individual", data: null }))
      );
    }

    // Fetch corporate documents
    if (companyProfileId > 0) {
      promises.push(
        axios
          .get(`${API}/profile/corporate/documents/${companyProfileId}`, {
            headers: { Authorization: `Bearer ${token}` },
          })
          .then((response) => ({
            type: "corporate",
            data: response.data,
          }))
          .catch(() => ({ type: "corporate", data: null }))
      );
    }

    // Fetch law enforcement documents
    if (lawEnforcementProfileId > 0) {
      promises.push(
        axios
          .get(
            `${API}/profile/lawenforcement/documents/${lawEnforcementProfileId}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          )
          .then((response) => ({
            type: "lawEnforcement",
            data: response.data,
          }))
          .catch(() => ({ type: "lawEnforcement", data: null }))
      );
    }

    Promise.all(promises)
      .then((results) => {
        const existingDocuments = { ...this.state.existingDocuments };

        results.forEach((result) => {
          if (result.data) {
            switch (result.type) {
              case "individual":
                existingDocuments.individualNationalId =
                  result.data.nationalIdDocument;
                existingDocuments.individualPassport =
                  result.data.passportDocument;
                break;
              case "corporate":
                existingDocuments.corporatePrimaryContactNationalId =
                  result.data.primaryContactNationalIdDocument;
                existingDocuments.corporatePrimaryContactPassport =
                  result.data.primaryContactPassportDocument;
                existingDocuments.corporateBillingContactNationalId =
                  result.data.billingContactNationalIdDocument;
                existingDocuments.corporateBillingContactPassport =
                  result.data.billingContactPassportDocument;
                existingDocuments.corporateCR14 = result.data.cr14Document;
                existingDocuments.corporateCertificateOfIncorporation =
                  result.data.certificateOfIncorporationDocument;
                break;
              case "lawEnforcement":
                existingDocuments.lawEnforcementNationalId =
                  result.data.nationalIdDocument;
                break;
              default:
                break;
            }
          }
        });

        this.setState({ existingDocuments, loading: false });
      })
      .catch((error) => {
        this.setState({
          loading: false,
          msg:
            error?.response?.data?.message ||
            "Failed to load existing documents.",
          toastColor: "danger",
        });
      });
  }

  handleFileChange(documentKey, file) {
    this.setState((prevState) => ({
      documents: {
        ...prevState.documents,
        [documentKey]: file,
      },
      errors: {
        ...prevState.errors,
        [documentKey]: null,
      },
    }));
  }

  handleUpload(documentKey) {
    const token = sessionStorage.getItem("token");
    const file = this.state.documents[documentKey];

    if (!file) {
      this.setState((prevState) => ({
        errors: {
          ...prevState.errors,
          [documentKey]: "Please select a file to upload",
        },
      }));
      return;
    }

    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      return;
    }

    this.setState((prevState) => ({
      uploading: {
        ...prevState.uploading,
        [documentKey]: true,
      },
      msg: "",
      toastColor: "",
    }));

    const formData = new FormData();
    formData.append("file", file);

    // Determine upload endpoint based on document type
    let endpoint = "";
    let profileId = 0;
    let userId = parseInt(sessionStorage.getItem("userId")) || 0;

    // if (documentKey.startsWith("individual")) {
    //   endpoint = `/profile/individual/upload-document`;
    //   profileId = this.state.individualProfileId;
    // } else if (documentKey.startsWith("corporate")) {
    //   endpoint = `/profile/corporate/upload-document`;
    //   profileId = this.state.companyProfileId;
    // } else if (documentKey.startsWith("lawEnforcement")) {
    //   endpoint = `/profile/lawenforcement/upload-document`;
    //   profileId = this.state.lawEnforcementProfileId;
    // }

    formData.append("profileId", profileId);
    formData.append("documentType", documentKey);
    formData.append("systemMessageType", this.getDocumentTypeFromParam())

    endpoint = `/users/${userId}/update-document/${this.state.documentType}`

    axios
      .post(`${API}${endpoint}`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.success) {
          this.setState((prevState) => ({
            msg: `${this.getDocumentDisplayName(
              documentKey
            )} uploaded successfully!`,
            toastColor: "success",
            documents: {
              ...prevState.documents,
              [documentKey]: null,
            },
            existingDocuments: {
              ...prevState.existingDocuments,
              [documentKey]: response.data.document,
            },
          }));

          // Reset file input
          const fileInput = document.getElementById(`file-${documentKey}`);
          if (fileInput) fileInput.value = "";
        } else {
          this.setState({
            msg:
              response.data.message ||
              `Failed to upload ${this.getDocumentDisplayName(documentKey)}`,
            toastColor: "danger",
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.location.href = `/?redirectUrl=${window.location.pathname + window.location.search
            }`;
        }
        this.setState({
          msg:
            error?.response?.data?.message ||
            `Failed to upload ${this.getDocumentDisplayName(
              documentKey
            )}. Please try again.`,
          toastColor: "danger",
        });
      })
      .finally(() => {
        this.setState((prevState) => ({
          uploading: {
            ...prevState.uploading,
            [documentKey]: false,
          },
        }));
      });
  }

  getDocumentDisplayName(documentKey) {
    const names = {
      individualNationalId: "Individual National ID",
      individualPassport: "Individual Passport",
      corporatePrimaryContactNationalId:
        "Corporate Primary Contact National ID",
      corporatePrimaryContactPassport: "Corporate Primary Contact Passport",
      corporateBillingContactNationalId:
        "Corporate Billing Contact National ID",
      corporateBillingContactPassport: "Corporate Billing Contact Passport",
      corporateCR14: "Corporate CR14",
      corporateCertificateOfIncorporation:
        "Corporate Certificate of Incorporation",
      lawEnforcementNationalId: "Law Enforcement National ID",
    };
    return names[documentKey] || documentKey;
  }

  renderDocumentField(documentKey) {
    const { documents, existingDocuments, uploading, errors } = this.state;
    const displayName = this.getDocumentDisplayName(documentKey);
    const existingDoc = existingDocuments[documentKey];
    const isUploading = uploading[documentKey];
    const error = errors[documentKey];

    return (
      <div key={documentKey} className="form-blue-card mt-3">
        <div className="form-blue-card-grid space-y-3">
          <div className="col-span-2 font-bold">{displayName}</div>

          {existingDoc ? (
            <div className="col-span-2">
              <div className="flex items-center justify-between p-3 bg-green-50 border border-green-200 rounded">
                <div className="flex items-center">
                  <i className="bi bi-check-circle-fill text-green-500 mr-2"></i>
                  <span className="text-green-700">
                    Document uploaded:{" "}
                    {existingDoc.originalName || "Document.pdf"}
                  </span>
                  {existingDoc.uploadDate && (
                    <span className="text-sm text-gray-500 ml-2">
                      ({new Date(existingDoc.uploadDate).toLocaleDateString()})
                    </span>
                  )}
                </div>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => {
                    // Reset existing document to allow new upload
                    this.setState((prevState) => ({
                      existingDocuments: {
                        ...prevState.existingDocuments,
                        [documentKey]: null,
                      },
                    }));
                  }}
                >
                  Change
                </button>
              </div>
            </div>
          ) : (
            <>
              <div className="input-group">
                <label
                  htmlFor={`file-${documentKey}`}
                  className="input-group-text"
                >
                  Select Document
                </label>
                <input
                  id={`file-${documentKey}`}
                  type="file"
                  className={`form-control ${error ? " !border-red-500" : ""}`}
                  accept=".pdf,.jpg,.jpeg,.png,.gif"
                  onChange={(e) =>
                    this.handleFileChange(documentKey, e.target.files[0])
                  }
                />
                {error && <span className="input-group-error">{error}</span>}
              </div>

              <div className="flex justify-end">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => this.handleUpload(documentKey)}
                  disabled={isUploading || !documents[documentKey]}
                >
                  {isUploading ? (
                    <>
                      <i className="bi bi-arrow-clockwise animate-spin mr-2"></i>
                      Uploading...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-upload mr-2"></i>
                      Upload
                    </>
                  )}
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { loading, msg, toastColor } = this.state;

    let divMsg = null;
    if (msg) {
      divMsg = (
        <div
          className={
            toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {msg}
        </div>
      );
    }

    if (loading) {
      return <Spinner className="" />;
    }

    const documentKeys = [
      "individualNationalId",
      "individualPassport",
      "corporatePrimaryContactNationalId",
      "corporatePrimaryContactPassport",
      "corporateBillingContactNationalId",
      "corporateBillingContactPassport",
      "corporateCR14",
      "corporateCertificateOfIncorporation",
      "lawEnforcementNationalId",
    ];

    const visibleDocuments = documentKeys.filter((key) =>
      this.shouldShowDocument(key)
    );

    return (
      <div className="min-vh-100 d-flex justify-content-between bg-white">
        <Sidebar />
        <div className="min-vh-100 flex-grow-1 d-flex flex-column">
          <Banner title="Upload Documents - Complete Profile" />
          {divMsg}

          <div className="d-flex flex-column flex-grow-1 px-5 h-60 overflow-auto">
            <div className="d-flex flex-column align-items-center w-100 mt-2 pt-3 pb-2">
              <div className="w-100" style={{ maxWidth: 62 + 'rem' }}>
                {visibleDocuments.length === 0 ? (
                  <div className="text-center text-muted mt-8">
                    <i className="bi bi-info-circle text-4xl mb-4"></i>
                    <p>No documents required for upload at this time.</p>
                  </div>
                ) : (
                  <>
                    <div className="mb-4 p-4 bg-primary bg-opacity-10 border border-primary rounded">
                      <h3 className="fw-bold text-primary mb-2">
                        <i className="bi bi-info-circle mr-2"></i>
                        Document Upload Instructions
                      </h3>
                      <ul className="text-primary small">
                        <li>• Accepted formats: PDF, JPG, JPEG, PNG, GIF</li>
                        <li>• Maximum file size: 10MB per document</li>
                        <li>• Ensure documents are clear and readable</li>
                        <li>
                          • Each document uploads to its specific endpoint
                        </li>
                      </ul>
                    </div>

                    {visibleDocuments.map((documentKey) =>
                      this.renderDocumentField(documentKey)
                    )}
                  </>
                )}

                <div className="d-flex justify-content-center gap-3 mt-6">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => window.history.back()}
                  >
                    <i className="bi bi-arrow-left mr-2"></i>
                    Back
                  </button>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    );
  }
}
